import { useToast } from '@chakra-ui/react'
import { useInstitutionsContext } from 'contexts/institutions'
import { GlobalFilter } from 'pages/components/GlobalFilter'
import { useRef, useState } from 'react'
import { ModeTable } from './components/ModeTable'
import { formFilter } from './form'
import { filterSchema } from './schema'
import { AccessFilter } from './types'

export const Onlines = () => {
    const toast = useToast()
    const { currentInstitution } = useInstitutionsContext()
    const [filter, setFilter] = useState<AccessFilter>({})
    const refModeTable = useRef<any>(null)

    const setCurrentFilters = (value: any) => {
        setFilter(value)
        refModeTable?.current?.resetPage && refModeTable?.current?.resetPage()
    }
    
    return (
        <>
            <GlobalFilter
                schema={filterSchema}
                form={formFilter}
                actionFilter={setCurrentFilters}
                loadingFilter={false}
                title="Filtrar Usuários Conectados"
            />

            <ModeTable
                filter={filter}
                ref={refModeTable}
            />
        </>
    )
}